import * as reduxLogger from './reduxLogger';
export default {
  reduxLogger: reduxLogger
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-act/esm/loggers/index.js
// module id = 2372
// module chunks = 0